<template>
  <v-container
    id="liga-forms"
    fluid
    tag="section"
  >
    <base-material-card
      color="#ac8a2e"
      icon="mdi-badge-account-horizontal-outline"
      inline
      class="px-5 py-3"
      title="Informes"
    >
      <template v-if="$can('M_informes_edita')" v-slot:after-title>
        <v-btn
          color="#ac8a2e"
          dark
          icon
          @click="goToNewInformeForm('new', 0)"
        >
          <v-icon
            large
            color="#ac8a2e"
          >
            mdi-text-box-plus-outline
          </v-icon>
        </v-btn>
      </template>
      <v-row>
      <v-col cols="12" lg="3">
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          min-width="290px"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-text-field v-model="fechaDesde" color="gold" label="Desde" readonly v-on="on" clearable @input="getInformes" />
          </template>
            <v-date-picker
              v-model="fechaDesde"
              color="gold"
              landscape
              scrollable
              locale="es-419"
              no-title
              @input="menu = false"
              @change="getInformes"
            >
            </v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" lg="3">
        <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          min-width="290px"
          offset-y
        >
          <template v-slot:activator="{ on }">
            <v-text-field v-model="fechaHasta" color="gold" label="Hasta" readonly v-on="on" clearable @input="getInformes" />
          </template>
            <v-date-picker
              v-model="fechaHasta"
              color="gold"
              landscape
              scrollable
              locale="es-419"
              no-title
              @input="menu1 = false"
              @change="getInformes"
            >
            </v-date-picker>
        </v-menu>
      </v-col>
      <v-col cols="12" lg="6">
          <v-text-field
            v-model="buscar"
            append-icon="mdi-magnify"
            class="ml-auto"
            color="gold"
            label="Buscar"
            hide-details
            single-line
            style="max-width: 250px;"
          />
      </v-col>
      </v-row>
      <v-divider class="mt-3" />

      <v-data-table
        :headers="headers"
        :items="informes"
        :search.sync="buscar"
        :sort-by="['fecha']"
        :sort-desc="[true, false]"
        multi-sort
        @click:row="showItem"
      >
        <template v-slot:[`item.propio_sn`]="{ item }">
          <v-icon
            v-if="item.propio_sn"
            medium
            color="green"
          >
            mdi-checkbox-marked-circle-outline
          </v-icon>
        </template>
        <template v-if="$can('M_informes_edita')" v-slot:[`item.actions`]="{ item }">
          <v-tooltip content-class="top" top>
            <template v-if="$can('M_informes_edita')" v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click.stop="goToNewInformeForm('edit', item.id)"
              >
                mdi-pencil
              </v-icon>
            </template>
            <span>Editar</span>
          </v-tooltip>
          <v-tooltip content-class="top" top>
            <template v-if="$can('M_informes_edita')" v-slot:activator="{ on, attrs }">
              <v-icon
                small
                class="mr-2"
                v-bind="attrs"
                v-on="on"
                @click.stop="deleteItem(item)"
              >
                mdi-delete
              </v-icon>
            </template>
            <span>Eliminar</span>
          </v-tooltip>
          <v-tooltip content-class="top" top>
            <template v-slot:activator="{ on, attrs }">
              <v-icon small v-bind="attrs" v-on="on" @click.stop="goToHistorial(item.id)">
                mdi-forum
              </v-icon>
            </template>
            <span>Acciones</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </base-material-card>
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
  import confirm from '../../../components/confirm'

  export default {
    components: {
      confirm,
    },
    data () {
      return {
        menu: false,
        menu1: false,
        fechaDesde: null,
        fechaHasta: null,
        buscar: undefined,
        headers: [
          { text: 'Fecha', sortable: true, value: 'fecha' },
          { text: 'Jugador', sortable: true, value: 'fullName' },
          { text: 'Creado por', sortable: true, value: 'scout.fullName' },
          { text: 'Acciones', value: 'actions', sortable: false, align: 'end' },
        ],
        informes: [],
        editedIndex: -1,
        dataForm: {
          id: '',
          fecha: '',
          jugador_id: '',
          scout_id: '',
          descripcion: '',
          documento_id: null,
          tieneAcciones: false,
        },
      }
    },
    created () {
      this.getInformes()
    },
    methods: {

      getInformes: async function () {
        this.$store.dispatch('axiosMod/getData', { url: '/api/informe_get/' + this.fechaDesde + '/' + this.fechaHasta }).then(response => { this.informes = response })
      },

      goToNewInformeForm: function (modeVal, idUser) {
        this.$router.push({ name: 'Alta Informe', params: { mode: modeVal, id: idUser } })
      },

      goToAsignaciones: function (idLitigio) {
        this.$router.push({ name: 'Asignaciones legales', params: { id: idLitigio } })
      },

      goToHistorial: function (idLitigio) {
        this.$router.push({ name: 'Acciones informe', params: { id: idLitigio } })
      },

      showItem (item) {
        this.goToHistorial(item.id)
      },

      deleteItem (item) {
        this.$refs.confirm.open('Alerta', 'También eliminará las acciones.', { color: 'red' }).then((confirm) => {
          if (confirm) {
            this.deleteItemConfirm(item)
          }
        })
      },

      deleteItemConfirm: async function (item) {
        await this.$http.delete('/api/informe_delete/' + item.id,
                                {
                                  headers: { Authorization: 'Bearer ' + this.$store.state.token },
                                },
        ).then(response => {
          this.$store.commit('toast/show', { tipo: 'success', messages: ['Informe eliminado'] })
        }).catch(error => {
          if (error.response.data.errors) {
            this.$store.commit('toast/show', { tipo: 'error', messages: error.response.data.errors })
          } else {
            this.$store.commit('toast/show', { tipo: 'error', messages: ['Ocurrio un error en el servidor'] })
          }
        })
        this.getInformes()
      },
    },
  }
</script>
